import { IEvaluations, EEvaluationStatus } from "../../../auditoinnit/interfaces/IEvaluation";
import { TMapAuditingCheck, TMapAuditingValue } from "../IMapAuditing";

export const CheckItemId = () => {

    return "Liikennemerkki_" + Math.random().toString(9).substr(2, 4);
};

export const isAuditCheckANote = (checkData: TMapAuditingCheck) => {
    return checkData.description?.length || checkData.images?.length;
};


export const mapAuditingToEvaluations = (value: TMapAuditingValue, basePath: string): IEvaluations => {
    let evaluations: IEvaluations = {};

    Object.keys(value).forEach((key) => {
        const status =
            value[key]?.status === "korjattavaa" ? EEvaluationStatus.NotOkay
                : value[key]?.status === "kunnossa" ? EEvaluationStatus.Okay
                    : EEvaluationStatus.Uknown

        evaluations[`${basePath}.${key}`] = { status };
    })

    return evaluations;
};